import { AccountAvatar } from '@/features/AccountAvatar';
import { Meta } from '@/features/Meta';
import { FeedbackBlankError } from '@/shared/components/FeedbackBlank';
import { Layout } from '@/shared/components/Layout';

export const NotFound = () => (
    <Layout accountSlot={<AccountAvatar />}>
        <Meta />
        <FeedbackBlankError
            title="404 Страница не найдена"
            subtitle=" Вы перешли по неправильной ссылке или страница была удалена"
        />
    </Layout>
);
